$('#realEstateAgencyList').on("click", ".poptat-firmu", function (event) {
    var fids = event.target.dataset.fids;
    console.log('poptat-firmu' + fids);

    $.ajax({
        type: 'GET',
        url: "/firmy/ajax_poptavka/",
        data: {fids: fids, galabel: 'vypis-rk-form-sent'},
        beforeSend: function () {
        },
        success: function (ret) {
            console.log('poptavka loaded');
            if(ret.status) {
                $("#ajax_poptavka").html(ret.content);
            }
        },
        complete: function () {
        }
    });

});

$("#realEstateAgencyFilter").on("change", function () {
    $("#form_filter").submit();
});